/**
 * ----------------------------------------------------------------------------
 * Funzione per stamparsi il prezzo
 * ----------------------------------------------------------------------------
 */

const renderPrice = (price, comparePrice, currency, container) => {
  let discount;
  let priceTemplate_html;
  let priceFormatted = price.replace(".", ",") + "0";

  //Prezzo se scontato
  if (comparePrice && +comparePrice.amount > +price) {
    discount = Math.floor(100 - (parseFloat(price) * 100) / parseFloat(comparePrice.amount));
    // container.parentNode.parentNode.querySelector(".ProductItem__Label").textContent = window.languages.labelOnSale;

    priceTemplate_html = `
      <span class="ProductItem__Price Price Price--compareAt Text--subdued">
        ${currency} ${comparePrice.amount.replace(".", ",")}0
      </span>
      <span class="ProductItem__Price Price Price--discount Text--subdued">${discount}%</span>
      <span class="ProductItem__Price Price Price--highlight Text--subdued"">${currency} ${priceFormatted}</span>`;
  } else {
    // prezzo se non presente lo sconto
    priceTemplate_html = `<div class="ProductItem__PriceList Heading">
        <span class="ProductItem__Price Price Price--highlight Text--subdued"">${currency} ${priceFormatted}</span>
      </div>`;
  }

  // Stampo nel div il prezzo
  container.innerHTML = priceTemplate_html;
};

/**
 * ----------------------------------------------------------------------------
 * Funzione per stamparsi le taglie
 * ----------------------------------------------------------------------------
 */

const renderSize = (variants, container) => {
  const indexVariantsSorted = Object.entries(variants).sort(([, a], [, b]) => a.node.index_size.value - b.node.index_size.value);

  let sizes_html = "";

  for (variant of indexVariantsSorted) {
    sizes_html += `<div class="ProductItem__Details__sizes__entry ${!variant[1].node.availableForSale && "ProductItem__Details__sizes__entry--unavailable"}">${variant[1].node.title}</div>`;
  }
  container.innerHTML = sizes_html;
};

/**
 * ----------------------------------------------------------------------------
 * Funzione per stamparsi le labels
 * ----------------------------------------------------------------------------
 */

const renderLabels = (labels, container) => {
  for (const label of labels) {
    if (label.includes("label:")) {
      const tag = label.split("_");
      container.textContent = tag[1];
      break;
    }
  }
};

/**
 * ----------------------------------------------------------------------------
 * Funzione per stamparsi i color swatchers
 * ----------------------------------------------------------------------------
 */

const renderSwatches = (siblings, productHandle, container) => {
  let colorSwatcher_html = "";
  for (const sibling of siblings) {
    const siblingUrl = window.routes.rootUrlWithoutSlash + "products/" + sibling;

    colorSwatcher_html += `<a href="${siblingUrl}" class="ProductItem__Swatches__Option ${productHandle == siblings && "ProductItem__Swatches__Option--selected"}">
        <div id="${sibling}" class="ProductItem__Swatch">
          <div class="ProductItem__Swatch__Color ProductItem__Swatch__Color--undefined"></div>
        </div>
      </a>
    `;

    container.innerHTML = colorSwatcher_html;
  }
};

/**
 * ----------------------------------------------------------------------------
 * Funzione fetch prodotti
 * ----------------------------------------------------------------------------
 */

const fecthProductShopLook = (handle, productContainerID) => {
  fetch("https://baracuta.myshopify.com/api/2023-10/graphql.json?", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": "c60b8400798b4774afd44b9003ba51df",
    },
    body: JSON.stringify({
      query: `query @inContext(country: ${window.theme.localizationISO}, language: ${window.theme.languageISO}){
        product(handle: "${handle}") 
        {title,
          id, 
          handle,
          vendor,
          onlineStoreUrl,
          tags,
          featuredImage{url},
          images(first:2){
            edges{
              node{
                url(transform: {maxWidth: 600}),
              }
            }
          },
          options {
            name,
            values
          },
          variants(first:100) {
            edges {
              node{
                price{amount, currencyCode},
                compareAtPrice{amount, currencyCode},
                title,
                availableForSale,
                index_size: metafield(namespace: "product_variant_info", key: "index") {value}
              }
            }
          },
          color_name: metafield(namespace: "product_info", key: "color_name") {
            value
          },
        },
      }`,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.data.product != null) {
        // Mi salvo i dati in un oggetto più carino
        let productObject = {
          id: data.data.product.id,
          handle: data.data.product.handle,
          title: data.data.product.title,
          vendor: data.data.product.vendor,
          producUrl: data.data.product.onlineStoreUrl,
          tags: data.data.product.tags,
          featureImage: data.data.product.featuredImage.url,
          altenateImage: data.data.product.images.edges[1].node.url,
          sizes: data.data.product.options[0].values,
          price: data.data.product.variants.edges[0].node.price.amount,
          comparePrice: data.data.product.variants.edges[0].node.compareAtPrice,
          colorName: data.data.product.color_name.value,
          variants: data.data.product.variants.edges,
        };

        // // Sostituisco i placeholder del "product-item-placeholder-look.liquid" con i dati
        let productContainers = document.querySelectorAll('[data-product-container-id="' + productContainerID + '"]');

        for (const container of productContainers) {
          const productUrlLocale = window.routes.rootUrlWithoutSlash + "/products/" + productObject.handle;
          const currencySymbols = window.theme.currency + " " + window.theme.currencySymbol;
          const priceDiv = container.querySelector(".ProductMeta__PriceList");
          const sizesDiv = container.querySelector(".ProductItem__Details__sizes");

          container.querySelector(".ProductItem__Image--main").setAttribute("data-src", productObject.featureImage);

          if (container.querySelector(".ProductItem__Image--main").hasAttribute("src", productObject.featureImage)) {
            container.querySelector(".ProductItem__Image--main").setAttribute("src", productObject.featureImage);
          }
          container.querySelector(".ProductItem__Image--alternate").setAttribute("data-src", productObject.altenateImage);
          if (container.querySelector(".ProductItem__Image--alternate").hasAttribute("src", productObject.altenateImage)) {
            container.querySelector(".ProductItem__Image--alternate").setAttribute("src", productObject.altenateImage);
          }
          container.querySelector(".ProductItem__Title").innerHTML = productObject.title;
          container.querySelector(".ProductItem__Color").innerHTML = productObject.colorName;
          Array.from(container.querySelectorAll(".ProductItem__ButtonLink")).forEach((e) => {
            e.setAttribute("href", productUrlLocale);
          });

          renderPrice(productObject.price, productObject.comparePrice, currencySymbols, priceDiv);

          // Funzione per stampare le taglie
          renderSize(productObject.variants, sizesDiv);
        }
      }
    })
    .catch((error) => console.log(error));
};
